import { render, staticRenderFns } from "./PortfolioProjectDetailsComponent.vue?vue&type=template&id=63010e73&scoped=true&"
import script from "./PortfolioProjectDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioProjectDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioProjectDetailsComponent.vue?vue&type=style&index=0&id=63010e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63010e73",
  null
  
)

export default component.exports